import React from "react";
import PropTypes from "prop-types";

import "./List.css";

/**
 * Display a list of children, or a placeholder if the list is empty.
 * Also allows for reversing the display order of the children.
 */
export default class List extends React.Component {
  
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.arrayOf(PropTypes.node)
    ]).isRequired,
    /**
     * Will be displayed if no children are passed.
     */
    placeholder: PropTypes.node,
    /**
     * If true, children will be shown in reverse order.
     * Scrolling will also start from the bottom rather than the top.
     */
    reversed: PropTypes.bool,
    className: PropTypes.string
  }
  
  static defaultProps = {
    placeholder: null,
    reversed: false
  }
  
  hasChildren() {
    return React.Children.count(this.props.children) > 0;
  }
  
  getClassNames() {
    const classNames = [ "list" ];
    if (this.props.className !== undefined) {
      classNames.push(this.props.className);
    }
    return classNames.reduce((classNames, className) => {
      classNames.push(className);
      classNames.push(this.hasChildren() ? `${className}--non-empty` : `${className}--empty`);
      classNames.push(this.props.reversed ? `${className}--reversed` : `${className}--non-reversed`);
      return classNames;
    }, []);
  }
  
  render() {
    const { children, placeholder } = this.props;
    return (
      <div className={this.getClassNames().join(" ")}>
        { this.hasChildren() ? children : placeholder }
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/components/List.js